import { render } from "./LocationFullCard.vue?vue&type=template&id=0c3c4a55"
import script from "./LocationFullCard.vue?vue&type=script&lang=js"
export * from "./LocationFullCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__